import { EventBus } from "../../eventBus";

export default {
    created() {
        EventBus.on('editorChanged', (props) => {
            this[props.prop] = props.value;
        });
    },
};
